import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { UserShippingAddress } from '../../../models/shopping';
import { AccountApiService } from '../../../services/apis/account-api.service';
import { Button } from '../../common/button/button';
import { UpdateUserShippingAddressDialog } from '../update-user-shipping-address-dialog/update-user-shipping-address-dialog';
@Component({
  selector: 'app-select-user-shipping-address-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    Button,
    MatProgressSpinnerModule,
    NzEmptyModule,
    MatIconModule,
    MatRadioModule,
  ],
  templateUrl: './select-user-shipping-address-dialog.html',
  styleUrl: './select-user-shipping-address-dialog.scss',
})
export class SelectUserShippingAddressDialog implements OnInit {
  selected: UserShippingAddress | null = null;
  constructor(
    private dialogRef: MatDialogRef<SelectUserShippingAddressDialog>,
    private accountApi: AccountApiService,
    private dialog: MatDialog
  ) {}

  close(r: any = null) {
    this.dialogRef.close(r);
  }

  ngOnInit(): void {
    this.findUserShippingAddresses();
  }

  loading: boolean = false;
  addresses: UserShippingAddress[] = [];
  async findUserShippingAddresses() {
    try {
      this.loading = true;
      this.addresses = await this.accountApi.findUserShippingAddresses();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  select(address: UserShippingAddress) {
    this.selected = address;
  }

  edit(event: Event, addr?: UserShippingAddress) {
    event.preventDefault();
    event.stopPropagation();
    this.dialog
      .open(UpdateUserShippingAddressDialog, {
        width: '640px',
        data: addr,
      })
      .afterClosed()
      .subscribe((r) => {
        if (r) {
          this.findUserShippingAddresses();
        }
      });
  }

  confirm() {
    this.close(this.selected);
  }
}
